const baseColors = {
    pureWhite: '#FFFFFF', // texto/ícone sobre cor (não escurece no dark)
    // ==== tokens auto-gerados pelo codemod (golden rule: light == hex original) ====
    c000000: '#000000',
    c0078d7: '#0078d7',
    c16a34a: '#16a34a',
    c1a202c: '#1a202c',
    c1e293b: '#1e293b',
    c1e3a8a: '#1e3a8a',
    c1e40af: '#1e40af',
    c1f2937: '#1f2937',
    c212529: '#212529',
    c2d3748: '#2d3748',
    c374151: '#374151',
    c495057: '#495057',
    c4a5568: '#4a5568',
    c64748b: '#64748b',
    c64748b4d: '#64748b4d',
    c6b7280: '#6b7280',
    c6c757d: '#6c757d',
    c6d6d6d: '#6d6d6d',
    c718096: '#718096',
    c797979: '#797979',
    c7c3aed: '#7c3aed',
    c808080: '#808080',
    c92400e: '#92400e',
    c94a3b8: '#94a3b8',
    c999999: '#999999',
    c9ca3af: '#9ca3af',
    ca0a096: '#a0a096',
    ca0aec0: '#a0aec0',
    ca8a8a8: '#a8a8a8',
    cbe185d: '#be185d',
    cc1c1c1: '#c1c1c1',
    cc9243a: '#c9243a',
    ccbd5e0: '#cbd5e0',
    ccbd5e1: '#cbd5e1',
    cd1d5db: '#d1d5db',
    cd32f2f: '#d32f2f',
    cd41e35: '#d41e35',
    cdbeafe: '#dbeafe',
    cdc2626: '#dc2626',
    cdc3545: '#dc3545',
    cdcfce7: '#dcfce7',
    ce0e0e0: '#e0e0e0',
    ce2e8f0: '#e2e8f0',
    ce3f2fd: '#e3f2fd',
    ce53e3e: '#e53e3e',
    ce5e5e5: '#e5e5e5',
    ce5e7eb: '#e5e7eb',
    ce9ecef: '#e9ecef',
    ced354e: '#ed354e',
    ced354e1a: '#ed354e1a',
    cedf2f7: '#edf2f7',
    cf0f0f0: '#f0f0f0',
    cf0fdf4: '#f0fdf4',
    cf1f1f1: '#f1f1f1',
    cf1f5f9: '#f1f5f9',
    cf1f5f94d: '#f1f5f94d',
    cf3e8ff: '#f3e8ff',
    cf3f4f6: '#f3f4f6',
    cf3f7fb: '#f3f7fb',
    cf5f5f5: '#f5f5f5',
    cf7fafc: '#f7fafc',
    cf8f8f8: '#f8f8f8',
    cf8f9fa: '#f8f9fa',
    cf8fafc: '#f8fafc',
    cf9fafb: '#f9fafb',
    cfafcfd: '#fafcfd',
    cfce7f3: '#fce7f3',
    cfde8e8: '#fde8e8',
    cfee2e2: '#fee2e2',
    cfef2f2: '#fef2f2',
    cfef3c7: '#fef3c7',
    cffe5e8: '#ffe5e8',
    cfff7f8: '#fff7f8',

    white: '#FFF',
    background: '#F6F8FA',
    backgroundMain: '#F7F7FA',

    primaryBlue100: '#4361CD',
    primaryBlue200: '#3452C0',
    primaryBlue300: '#2E49A9',
    primaryBlue400: '#293F93',
    primaryBlue500: '#23367C',
    primaryBlue600: '#1A2858',

    primaryOrange50: '#FFF2DE',
    primaryOrange100: '#FFDEAE',
    primaryOrange200: '#FFCB7F',
    primaryOrange300: '#FEBE60',
    primaryOrange400: '#FDB141',
    primaryOrange500: '#FFA41F',
    primaryOrange600: '#FA9604',
    primaryOrange700: '#F18F00',

    secondaryGreen050: '#DDFAF4',
    secondaryGreen100: '#B8FFF2',
    secondaryGreen200: '#6DFFE5',
    secondaryGreen300: '#04FDD0',
    secondaryGreen400: '#02E8BE',
    secondaryGreen500: '#00D3AD',
    secondaryGreen600: '#03AD8F',

    secondaryPool100: '#E4F5FF',
    secondaryPool200: '#C1E8FF',
    secondaryPool300: '#ABE0FE',
    secondaryPool400: '#88D3FE',
    secondaryPool500: '#70CBFF',
    secondaryPool600: '#23ACFA',

    interfaceDanger: '#F24343',
    interfaceDanger100: '#FFEAED',
    interfaceDanger200: '#FFCACE',
    interfaceDanger300: '#F39493',
    interfaceDanger400: '#F24343',
    interfaceDanger500: '#E81E26',
    interfaceDanger600: '#BB0007',

    interfaceSuccess: '#0FC758',
    interfaceSuccess100: '#E7F8EB',
    interfaceSuccess200: '#C5EECE',
    interfaceSuccess300: '#9EE4AF',
    interfaceSuccess400: '#0FC758',

    interfaceText100: '#EAEEF3',
    interfaceText200: '#C5CED7',
    interfaceText300: '#8A99A8',
    interfaceText400: '#5A646E',
    interfaceText500: '#353A40',
    interfaceText600: '#374151',

    interfacePure0: '#FFF',
    interfacePure100: '#F2F2F2',
    interfacePure200: '#CCCCCC',
    interfacePure400: '#707070',
    interfacePure500: '#333333',
    interfacePure600: '#1C2225',

    
    // Red - Cor Primária da Marca
    redDev: 'red',
    primaryRed50: '#FFEAED',        // Vermelho Muito Claro (Background)
    primaryRed300: '#ffbfc7',       // Vermelho Claro
    primaryRed400: '#E52940',       // Cor principal - Tema
    primaryRed600: '#7e1925',       // Vermelho Escuro para Ícone 

    secondaryGray: '#7f919a',
    tertiaryGray: '#acbac2',
    
    // Gray - Interface ( Todo o espectro de cinza)
    interfaceGray100: '#798891',    // themeGray
    interfaceGray200: '#AFBDC5',    // themeGray2
    interfaceGray300: '#54666F',    // defaultGray
    interfaceGray400: '#3E4B52',    // textGray
    interfaceGray500: '#6F777E',    // defaultIconGray
    interfaceGray600: '#969DA3',    // profileGray / userComum
    interfaceGray700: '#5A646E',    // defaultIconBlack
    interfaceGray800: '#1C2225',    // defaultBlack
    interfaceGray900: '#96a1a7',    // input disable
    
    // Texto
    interfaceTextPrimary: '#333333', // textPrimary
    interfaceText: '#020817',
    interfaceTextGray: '#3E4B52',    // textGray (também usado acima)
    
    // Bordas
    interfaceBorder100: '#CCD6DB',   // borderGray

    // Botões desabilitados
    disabledBg: '#54666F',          // Fundo de botão desabilitado (interfaceGray300)
    disabledText: '#FFFFFF',        // Texto de botão desabilitado
}

export const comum = {
// cinza
    colors: {
        ...baseColors,
    }
}

export const admin = {
    // vermelho
    colors: {
        ...baseColors,
    }
}

export const operador = {
    colors: {
        ...baseColors,
    }
}